/**
 * [DEV ONLY] Captures the email-code header from security API responses
 * and copies it to clipboard with a notification.
 * 
 * This is only active in development mode to facilitate testing.
 */
import iziToast from 'izitoast'

/**
 * Check response headers for email-code and copy to clipboard (dev only)
 */
export const captureEmailCode = async (response: Response): Promise<void> => {
    if (!import.meta.env.DEV) return

    const emailCode = response.headers.get('email-code')
    if (!emailCode) return

    try {
        await navigator.clipboard.writeText(emailCode)

        iziToast.info({
            title: '📋 Dev: Email Code Copied',
            message: `Code: ${emailCode}`,
            position: 'topRight',
            timeout: 5000,
            close: true,
            progressBar: true,
            progressBarColor: '#532DE0',
            backgroundColor: '#2a2a3a',
            messageColor: '#fff',
            titleColor: '#fff',
        })

        console.log('[DEV] Email code copied to clipboard:', emailCode)
    } catch (err) {
        // Fallback if clipboard API fails
        console.warn('[DEV] Could not copy email code to clipboard:', emailCode)

        iziToast.warning({
            title: '📋 Dev: Email Code',
            message: `Code: ${emailCode} (clipboard failed, check console)`,
            position: 'topRight',
            timeout: 8000,
            close: true,
            progressBar: true,
        })
    }
}
